import _styled from "@emotion/styled-base";
import { N300 } from '@atlaskit/theme/colors';
import { ButtonClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import React from 'react';
import { Link } from 'react-router-dom';
import ExternalLink from "../../../../primitives/ExternalLink";
import { ANALYTICS_SUBJECT_ID_VENDOR_NAME } from "../../AppHeader.constants";
export const PartnerDetailsContainer = _styled("div", {
  target: "efj4mxg0",
  label: "PartnerDetailsContainer"
})("color:", N300, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

const HeaderPartnerDetails = props => {
  const {
    name,
    link,
    pathname,
    openMarketplaceLinksInNewTab,
    analyticsSourceAttribute
  } = props;
  const fireAnalyticsEvent = useAnalyticsEvents();

  const onNameClick = () => {
    fireAnalyticsEvent({
      eventType: ButtonClickedEvent,
      actionSubjectId: ANALYTICS_SUBJECT_ID_VENDOR_NAME,
      attributes: {
        source: analyticsSourceAttribute
      }
    });
  };

  if (!name) return null;

  if (!link && !pathname) {
    return /*#__PURE__*/React.createElement(PartnerDetailsContainer, null, "by\xA0", name);
  }

  if (openMarketplaceLinksInNewTab && link) {
    return /*#__PURE__*/React.createElement(PartnerDetailsContainer, null, "by\xA0", /*#__PURE__*/React.createElement(ExternalLink, {
      href: link,
      onClick: onNameClick
    }, name));
  }

  let path = '';

  if (pathname) {
    path = pathname;
  } else if (link) {
    path = new URL(link).pathname;
  }

  return /*#__PURE__*/React.createElement(PartnerDetailsContainer, null, "by\xA0", /*#__PURE__*/React.createElement(Link, {
    to: path,
    onClick: onNameClick
  }, name));
};

export default HeaderPartnerDetails;